import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=3c45df53&scoped=true&"
import script from "./Stock.vue?vue&type=script&lang=js&"
export * from "./Stock.vue?vue&type=script&lang=js&"
import style0 from "./Stock.vue?vue&type=style&index=0&id=3c45df53&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45df53",
  null
  
)

export default component.exports